<template>
  <div class="flex flex-col items-center w-full border-blue-800 border-8 p-2 p-2 lg:p-8">

        <ring-loader v-if="showLoader"></ring-loader>

      <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                     
            <label class="mr-5"><strong>{{$t('player.groupName')}}  </strong></label>
            
            <input v-model="groupName"
            class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4
             block appearance-none leading-normal text-center w-64"
             type="text" placeholder="Group Name" >
      </div>
       
          <!-- <label class="mr-5"><strong>Profile Picture: </strong></label> -->
        <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full pl-20">

            <button   class=" text-center rounded-lg p-3 lg:p-5 bg-pink-400" @click="onFileButtonClicked(i)">{{$t('pitch.uploadImage')}}</button>

                <img src="@/assets/images/full-logo.jpg" class="ml-5 rounded-lg" ref="groupImageRef" height="100"  width="100"/>

            <circle-loader v-if="isLoadingImage"></circle-loader>

            <input type="file"  accept="image/*" style="display: none;" ref="fileInput" @change="getImageEvent($event, i)">
        </div>
      
      <div  class="items-center mb-1 lg:mb-4">

        <button @click="uploadFileToFireBase"
          :disabled="isLoadingImage || showLoader"
        class="mt-5 lg:mt-30 w-24 lg:w-48  rounded bg-pink-500 text-white font-bold p-2 lg:p-4 uppercase border-blue-500 border">
        {{$t('profile.submit')}} </button>
      </div>
  </div>
</template>

<script>

import firebase from '../classes/firebase';

import { RingLoader } from 'vue-spinners-css';
import { CircleLoader } from 'vue-spinners-css';

import twoMyInserts from '../hasura/myTwoInserts';

import twoMyQueries from '../hasura/myTwoQueries';


import componentsHelpers from '../classes/componentHelpers';

export default {

    mounted(){
    
    // console.log(`inside createGroup`);
  },

    props:{

        myReload:{

            type: Function    
        },

        userId: 0,
        playerId: 0,
        playerName: '',
        email:''
    },

    methods:{

        callReload(){

            this.myReload();
        },

        async isNameAvailable(name){

            let groupNameQuery = await this.$apollo.query({

                query: twoMyQueries.players_groups_name_query,

                error(error){

                    this.allLoaded = false;

                    componentsHelpers.sendError(apollo, userId,'Group', ',createGroup', 'isNameAvailable' , error);
                
                    componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    // this.tokenError = JSON.stringify(error);
                },   
            });

            if(groupNameQuery.data.two_play_group.length > 0){

                componentsHelpers.toastIt(toast, this.$t('player.nameNotAvailable'), 3, 'outline', true);

                return false;
            }
            else{

                return true;
            }
        },

        async checkForm(){

          if(this.groupName == '' || this.groupName == null){

            componentsHelpers.toastIt(toast, this.$t('player.groupNameEmpty'), 3, 'outline', true);

              return;
          }
        },

        async createGroupMutate(){

            if(!this.checkForm()){

                return;
            }

            let groupInsertResult;

            try{

                let img = this.$refs.groupImageRef;

                // const componentsHelpers = componentsHelpers;

                const apollo = this.$apollo;

                const toast = this.$toasted;   

                const t = this.$t;
                
                const allPlayers = `${this.playerName}`;

                groupInsertResult = await this.$apollo.mutate({

                    mutation: twoMyInserts.group_insert,

                    variables: {

                        groupName: this.groupName,
                        playerId: this.playerId,
                        picture: img.src,
                        allPlayers: allPlayers,
                    },
                        
                    error(error){

                        this.showLoader = false;
                        this.mutationError = error;

                        // if(this.mutationError.includes('unique constraint "user_phone_key"'))
                        // {
                        
                        // // alert (`Error: Phone is already registered`);
                        // }
                        // console.log(`Fayez Error is ${JSON.stringify(error)}`);

                        componentsHelpers.sendError(apollo, 0, 'Group', 'createGroup', 'createGroupMutate',
                        error);

                        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                    }
                    });

                     componentsHelpers.toastIt(this.$toasted, this.$t('player.groupCreated'),
                     2,'bubble', true);

                    if(groupInsertResult.data.insert_two_play_group.affected_rows == 1){
                        
                        await this.insertGroupToPlayers(groupInsertResult.data.insert_two_play_group.returning[0].id, this.playerId);
                        const reload = this.callReload;

                        setTimeout(function(){

                            reload();
                        }, 3000);
                    }
                }
                catch(error){

                this.showLoader = false;

                componentsHelpers.sendError(this.$apollo, 0, 'Group', 'createGroup', 'createGroupMutate', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                this.mutationError = error;
            }
        },

        getUserId(){

            if(JSON.stringify(this.$userId) != '{}'){

                return this.$userId
            }
            else{

                return 0;
            }
        },

        async insertGroupToPlayers(groupId, playerId){

            const userId = this.getUserId;

            
            try{

                const groupToPlayerInsertResult = await this.$apollo.mutate({

                    mutation: twoMyInserts.group_to_players_insert,

                    variables: {

                        groupId: groupId,
                        playerId: playerId,
                    },
                        
                    error(error){

                        this.showLoader = false;
                        this.mutationError = error;

                        // if(this.mutationError.includes('unique constraint "user_phone_key"'))
                        // {
                        
                        // // alert (`Error: Phone is already registered`);
                        // }
                        // console.log(`Fayez Error is ${JSON.stringify(error)}`);

                        componentsHelpers.sendError(this.$apollo, userId, 'Group', 'createGroup', 'insertGroupToPlayers',
                        error);

                        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                    }
                    })
            }catch(error){

                componentsHelpers.sendError(this.$apollo, userId, 'Group', 'createGroup', 'insertGroupToPlayers-catchError',
                error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

            }
        },

        onFileButtonClicked(){

            this.$refs.fileInput.click();
        },

        getImageEvent(event){

            let img = this.$refs.groupImageRef;

            const fileReader = new FileReader();
            
            fileReader.addEventListener('load', () => {

                img.src = fileReader.result
                this.isLoadingImage = false;
            });
        

            const apollo = this.$apollo;

            const toasted = this.$toasted;

            const t = this.$t;

            fileReader.onerror = function(event) {

                componentsHelpers.sendError(apollo, 0,'group', 'createGroup', 'getImageEvent', this.$t('profile.loadedImageError'));

                componentsHelpers.toastIt(toast, this.$t('profile.loadedImageError'), 3, 'outline', true);
                
                this.isLoadingImage = false;

            };
            
            if(event.target.files.length > 0){

                this.imageFile = event.target.files[0];

                this.isLoadingImage = true;
                fileReader.readAsDataURL(this.imageFile);
            }
        },


        uploadFileToFireBase(){
        
            let img = this.$refs.groupImageRef;

            const submitFunction = this.createGroupMutate;

            let getFile = this.imageFile;

            if(this.checkForm())
            {

                if(getFile != null){

                let fileExtension = getFile.name.substr(getFile.name.lastIndexOf('.'));
                //set storage ref

                // const targetLocation = 'p-nadi/images/'+this.email + `(User)/${this.email + ' PC ' + new Date().getTime()+ fileExtension}`;
                const targetLocation = 'p-nadi/images/'+ this.email + `(User)/groups/playerId-${this.playerId} - group-${this.groupName}`  + `${fileExtension}`;

                // console.log(`Target location is ${targetLocation}`);

                let storageRef = firebase.storage().ref(targetLocation);

                // console.log(`storageRef is ${storageRef}`);
                
                this.isLoadingImage = true;
                let task = storageRef.put(getFile);

                // const componentsHelpers = componentsHelpers;

                const apollo = this.$apollo;

                const toast = this.$toasted;

                task.on('state_changed',
                    function progress(snapshot){
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;

                    // this.uploadingPercentage = percentage + '%';
                    
                    // this.uploadingPercentage = this.uploadingPercentage + 10;

                    this.isLoadingImage = false;

                    const t = this.$t;

                    // console.log(`percentage is ${percentage}`);
                    },
                    function error(err){
                    // console.log(err);

                    componentsHelpers.sendError(apollo, 0,'Group', 'createGroup', 'uploadFileToFireBase - task.on-1', error);

                    componentsHelpers.toastIt(toast, this.$t('profile.loadedImageError'), 3, 'outline', true);

                    // alert('Image could not be loaded');

                    this.isLoadingImage = false;
                    },
                    function complete(res){
                    //  console.log(`complete upload with ${res}`);
                    

                    // console.log(`all url objects are ${task.snapshot.ref}`);
                    task.snapshot.ref.getDownloadURL().then((url)=>{
                        
                        this.isLoadingImage = false;

                        this.picture = url.toString();

                        img.src = this.picture;

                        // console.log(`Img source is ${this.picture}`);

                        submitFunction();

                    });
                    }
                );
                
                // const componentsHelpers = componentsHelpers;

                // const apollo = this.$apollo;

                // const toast = this.$toasted;

                const t = this.$t;

                task.then(snapshot => {
                    this.isLoadingImage = false;
                }).catch(error => {

                    this.isLoadingImage = false;

                    componentsHelpers.sendError(apollo, 0,'group', 'createGroup', 'uploadFileToFireBase - task.on-2', error);

                    componentsHelpers.toastIt(toast, this.$t('profile.errorOccured'), 3, 'outline', true);
                    // alert('Error has occured. Try again later');
                });
                }
                else{

                submitFunction();
                } 
            }
        }
    },

    data(){

        return{

            groupName: '',
            isLoadingImage: false,
            picture: '',
            showLoader: false,
        }
    }
}
</script>

<style>

</style>